import { ShieldStarOutlineIcon } from './ShieldStarOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 122D14B5-1EB6-4ED3-8765-7C8A58D6071B
 * name shield-star-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-star-outline.svg
 * tags
 */
export const ShieldFavoriteOutlineIcon = ShieldStarOutlineIcon;
export default ShieldFavoriteOutlineIcon